<template>
    <maintenances-find
        :params="{
            maintenance: $route.params.maintenance
        }"
        :include="[
            'files(filters:with_erased=false)',
            'job_sheets(include:contacts)',
        ]"
        v-slot="{
            data: maintenance,
            error,
            is_loading,
            has_loaded,
            find
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="find"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <base-hint
                v-if="false"
                name="landlords-maintenances-show"
            >
                <template slot="heading">
                    Viewing a maintenance
                </template>

                <p>
                    ...
                </p>
            </base-hint>

            <details-card
                class="mb-6 id-details-card"
                :is-open="true"
            >
                <template slot="header">
                    <div class="flex-grow mr-3 overflow-hidden">
                        <h1 class="text-lg font-normal truncate">
                            {{ maintenance.title }}
                        </h1>
                    </div>

                    <div
                        v-if="is_loading"
                        class="w-6 h-6 mr-3"
                    >
                        <base-svg
                            name="icon-loading"
                            class="w-full h-full"
                        />
                    </div>

                    <edit-dropdown
                        :maintenance="maintenance"
                        class="flex-none"
                        @success="find"
                    />
                </template>
                <template slot="body">
                    <grid-layout>
                        <grid-layout-item class="mb-3">
                            <div class="text-xs text-label">Property</div>
                            <div class="text-sm">
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.properties.show'),
                                        params: {
                                            property: maintenance.property.uuid
                                        }
                                    }"
                                    class="no-underline text-blue"
                                >
                                    {{ maintenance.property.name }}
                                </router-link>
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="mb-3">
                            <div class="text-xs text-label">Description</div>
                            <div class="text-sm">
                                <expandable-text
                                    :text="maintenance.description"
                                    :length="100"
                                />
                            </div>
                        </grid-layout-item>
                    </grid-layout>
                </template>
            </details-card>

            <job-sheets-card
                :data="maintenance.job_sheets.data"
                :meta="{}"
                :can-new="true"
                :new-to="{
                    name: $router.fix('dashboard.*.job-sheets.create'),
                    query: {
                        maintenance: maintenance.uuid
                    }
                }"
                class="mb-6"
            />

            <div class="mb-6 rounded shadow bg-grey-bg">
                <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
                    <h3 class="text-base font-normal">Files</h3>
                </header>

                <files-lists
                    :files="maintenance.files.data"
                    class="p-4 sm:px-6"
                />
            </div>
        </div>
    </maintenances-find>
</template>

<script>
    import DetailsCard from '../../../../components/details-card'
    import EditDropdown from './show/edit-dropdown'
    import FilesLists from '../../../../components/files-lists'
    import JobSheetsCard from '../../../../components/job-sheets-card'
    import MaintenancesFind from '../../../../components/maintenances-find'

    export default {
        components: {
            DetailsCard,
            EditDropdown,
            FilesLists,
            JobSheetsCard,
            MaintenancesFind
        }
    }
</script>
